import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CEPRepository, CEP_REPOSITORY } from '../repositories/cep.repository';
import { Endereco, ParametrosBuscaEndereco } from '../models/endereco.model';

/**
 * Caso de uso para busca de CEP por endereço
 * Implementa a lógica de negócio para buscar CEPs por UF, cidade e logradouro
 */
@Injectable({
  providedIn: 'root'
})
export class BuscarPorEnderecoUseCase {
  
  constructor(@Inject(CEP_REPOSITORY) private cepRepository: CEPRepository) {}

  /**
   * Executa a busca de CEP por endereço
   * @param parametros Parâmetros da busca (UF, cidade, logradouro)
   * @returns Observable com array de endereços encontrados
   */
  execute(parametros: ParametrosBuscaEndereco): Observable<Endereco[]> {
    // Lógica de negócio adicional pode ser adicionada aqui
    // Por exemplo: cache, rate limiting, etc.
    
    return this.cepRepository.buscarPorEndereco(parametros);
  }

  /**
   * Valida os parâmetros de busca
   * @param parametros Parâmetros a serem validados
   * @returns true se os parâmetros são válidos
   */
  validarParametros(parametros: ParametrosBuscaEndereco): boolean {
    const { uf, cidade, logradouro } = parametros;
    
    return !!uf && 
           !!cidade && 
           !!logradouro && 
           cidade.trim().length >= 3 && 
           logradouro.trim().length >= 3;
  }

  /**
   * Normaliza os parâmetros de busca (remove espaços extras, etc.)
   * @param parametros Parâmetros a serem normalizados
   * @returns Parâmetros normalizados
   */
  normalizarParametros(parametros: ParametrosBuscaEndereco): ParametrosBuscaEndereco {
    return {
      uf: parametros.uf.trim().toUpperCase(),
      cidade: parametros.cidade.trim(),
      logradouro: parametros.logradouro.trim()
    };
  }
}
